import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { exitFromAdmin, setCredentialsValue, sendCredentials } from './admin.actions';

import { Switch, Route, Redirect } from 'react-router-dom';

import Add from './sections/add/add';
import List from './sections/list/list';
import { Modal, Button } from 'antd'

import './admin.css';

class Admin extends Component {
  returnCredentialsModal() {
    const { inRequest, disabledModalButton } = this.props.admin;
    return (
      <Modal
        visible={false} title='Insira suas credenciais para continuar'
        closable={false}
        footer={[
          <Button key='cancel' onClick={this.props.exitFromAdmin} type='danger'>Cancelar</Button>,
          <Button key='submit' onClick={this.props.sendCredentials} type='primary' disabled={disabledModalButton} loading={inRequest}>Enviar</Button>
        ]}
      >
        <div className='input-modal-body'>
          <div className='inputs-section'>
            <div className='input-wrapper'>
              <input onChange={this.props.setCredentialsValue} id='username' type='text' placeholder='Usúario' />
            </div>
            <div className='input-wrapper'>
              <input onChange={this.props.setCredentialsValue} id='password' type='password' placeholder='Senha' />
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  render() {
    const { isAdmin } = this.props.admin;
    if (isAdmin) {
      return this.returnCredentialsModal();
    } else {
      return (
        <Switch>
          <Route path='/dashboard/admin/list' component={List} />
          <Route path='/dashboard/admin/add' component={Add} />
          <Route path='/dashboard/admin/edit/:id' component={Add} />
          <Redirect fom='/dashboard/admin' to='/dashboard/admin/list' />
        </Switch>
      );
    }
  }
}

const mapStateToProps = state => ({
  admin: state.admin
})

const mapDispatchToProps = dispatch => bindActionCreators({ exitFromAdmin, setCredentialsValue, sendCredentials }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Admin)


// WEBPACK FOOTER //
// ./src/App/containers/admin/admin.js